import React, {Component} from 'react';
import '../ChallengeStatement.css';
import Inputs from '../../../shared/FormComponents/Inputs';
import _ from 'lodash';

class ChallengeStatementFormFirst extends Component {
    constructor(props) {
      super(props);
      this.defaultParams = {};
      this.state = {
        
      };
    }

    render() {
        return(
            <div className='challenge-statement-form-content'>
                <div className='card'>
                    <div className='card-header'>
                        <h5>Horizon 1</h5>
                    </div>
                    <div className='card-body'>
                        <form>
                            <div className="form-group">
                                <label>How can...</label>
                                <Inputs
                                    type="name"
                                    className="form-control"
                                    value={this.props.createData.company}
                                    required={ true }
                                    placeholder='Company, product or business unit'
                                    onChange={ (value, valid) => this.props.onDataChange('company', value, valid, 'horizon1')} />
                            </div>
                            <div className="form-group">
                                <label>achieve...</label>
                                <Inputs
                                    type="name"
                                    className="form-control"
                                    value={this.props.createData.goal}
                                    required={ true }
                                    placeholder='Goal such as grow/maintain'
                                    onChange={ (value, valid) => this.props.onDataChange('goal', value, valid, 'horizon1')} />
                            </div>
                            <div className="form-group">
                                <label>in...</label>
                                <Inputs
                                    type="name"
                                    className="form-control"
                                    value={this.props.createData.category}
                                    required={ true }
                                    placeholder='Category and/or geography'
                                    onChange={ (value, valid) => this.props.onDataChange('category', value, valid, 'horizon1')} />
                            </div>
                            <div className="form-group">
                                <label>over the next...</label>
                                <Inputs
                                    type="name"
                                    className="form-control"
                                    value={this.props.createData.timeframe}
                                    required={ true }
                                    placeholder='Timeframe'
                                    onChange={ (value, valid) => this.props.onDataChange('timeframe', value, valid, 'horizon1')} />
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        ) 
    }
}

export default (ChallengeStatementFormFirst);



// WEBPACK FOOTER //
// ./src/components/ChallengeStatement/ChallengeStatementFormFirst/ChallengeStatementFormFirst.jsx